export default __webpack_public_path__ + "static/media/eternity_ring.bb2aaf60.webp";